// #region Imports

/* Telestream */
import { SET_INDEXER_CONNECTION, SET_INDEXER_PROGRESS } from '@/utils/mutation-types';
import {
  ADVANCE_INDEXING,
  END_INDEXING_OBSERVATION,
  JUMP_TO_TIME,
  OBSERVE_INDEXING,
  PAUSE_VIDEO,
} from '@/utils/action-types';
import { ConnectionService } from '@/services/connection.service';

// #endregion Imports

// #region Constants

const ADVANCE_OFFSET_IN_SECONDS     = 12; // Same as legacy client. Not sure of the significance.

// #endregion Constants

export const indexer = {
  // #region State

  state: {
    connection: undefined,
    progress:   undefined,
  },

  // #endregion State

  // #region Mutations

  mutations: {
    [SET_INDEXER_CONNECTION](state, connection) {
      state.connection = connection;
    },

    [SET_INDEXER_PROGRESS](state, progress) {
      state.progress = progress;
    },
  },

  // #endregion Mutations

  // #region Actions

  actions: {
    async [OBSERVE_INDEXING](context, { origin, path }) {
      const connection = ConnectionService.getHubConnection(origin, '/indexer', true);
      await connection.start();
      context.commit(SET_INDEXER_CONNECTION, connection);

      connection.on('UpdateProgress', (progress) => context.commit(SET_INDEXER_PROGRESS, progress));
      const progress = await connection.invoke('ObserveFile', path);
      context.commit(SET_INDEXER_PROGRESS, progress);
    },

    [END_INDEXING_OBSERVATION](context) {
      if (!context.state.connection) {
        return;
      }

      context.state.connection.stop();
    },

    async [ADVANCE_INDEXING](context, { isOpenFile, percentage }) {
      context.dispatch(PAUSE_VIDEO);

      const discontinuity = await context.state.connection.invoke('Advance', context.rootState.videoPath, isOpenFile, percentage);

      // This happens when advancing to a part that has already been indexed.
      if (discontinuity.end === 0) {
        return;
      }

      // If you jump exactly to the end of the discontinuity, the video may get stuck.
      context.dispatch(JUMP_TO_TIME, discontinuity.end + ADVANCE_OFFSET_IN_SECONDS);
    },
  },

  // #endregion Actions
};
